'use strict';

const _=require('pulsar-utils/dist-es6/_');

const cx=require('../../../dist-es6/shared/extensions/classExtensions');
const FlightViewModel=require('../../../dist-es6/client/viewModels/flightViewModel');
const DashboardPersonViewModel=require('../../../dist-es6/client/viewModels/dashboardPersonViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const fpe=require('pulsar-dashboard-core/dist-es6/extensions/fatiguePointExtensions');
const fe=require('../../../dist-es6/shared/extensions/fatigueExtensions');
const ae=require('../../../dist-es6/shared/extensions/assessmentsExtensions');let

FlightMonitorPersonViewModel=class FlightMonitorPersonViewModel extends DashboardPersonViewModel{
constructor(...args){
super(...args);
this._currentStatusSource='effectiveStatus';

this.alwaysDraw=!0;

cx(this).defineLazyGetters({
currentShift:()=>_.get(this,'statistics.currentShift',null),
schedule:()=>_.get(this,'statistics.schedule',null),
flights:()=>_.get(this,'statistics.schedule.flights',[]),
combinedDuties:()=>_.get(this,'statistics.schedule.duties',[]),
originalEffectiveStatus:()=>_.get(this,'statistics.effectiveStatus',{}),
currentStatus:()=>this._getCurrentStatus(),
flightDuties:()=>this.combinedDuties.filter(d=>this.flights.some(f=>f.intersects(d))),
currentFlight:()=>_.exists(this.originalEffectiveStatus.time)&&this.flights.find(f=>f.contains(this.originalEffectiveStatus.time)),
currentDuty:()=>_.exists(this.originalEffectiveStatus.time)&&this.combinedDuties.find(d=>d.contains(this.originalEffectiveStatus.time))});

}

getLegNumberFromDuty(flight){
const flightDutyIndex=this.getDutyIndexForFlight(flight);
if(flightDutyIndex===-1){
return 1;
}

const allFlightsWithSameDutyIndex=this.flights.filter(f=>this.getDutyIndexForFlight(f)===flightDutyIndex);

return allFlightsWithSameDutyIndex.indexOf(flight)+1;
}

getSidebarClassListForFlight(flight){
const classes=[];

const flightDutyIndex=this.getDutyIndexForFlight(flight);

if(flightDutyIndex===-1){
return['no-duty'];
}

const currentFlightDutyIndex=this.currentFlight?this.getDutyIndexForFlight(this.currentFlight):-1;
classes.push('duty-'+flightDutyIndex%2);

if(flight===this.currentFlight){
classes.push('current');
}else if(currentFlightDutyIndex!==-1&&
currentFlightDutyIndex===flightDutyIndex&&
flight.end.getTime()<this.currentFlight.start.getTime()){

classes.push('completed');
}else if(this.currentDuty&&
flight.intersects(this.currentDuty)&&
flight.end.getTime()<this.currentStatus.time.getTime()){

classes.push('completed');
}else if(!this.currentDuty&&flight.start.getTime()>this.currentStatus.time.getTime()){

const currentFlightIndex=this.flights.indexOf(flight);
const flightsEndingBeforeNow=this.flights.filter(f=>f.end.getTime()<this.currentStatus.time.getTime());

if(currentFlightIndex===flightsEndingBeforeNow.length){
classes.push('upcoming');
}
}

return classes;
}

getDutyIndexForFlight(flight){
return this.flightDuties.findIndex(d=>flight.intersects(d));
}

getThresholdStatusForFlight(flight){
return ThresholdStatus.fromScoreAndThreshold(flight.metrics.fatigue.tod,this.thresholdFor(NotificationType.FatigueThresholdExceeded));
}

_getCurrentStatus(){
const currentStatus=this.originalEffectiveStatus;

if(!_.exists(currentStatus.time)){
return currentStatus;
}

if(_.exists(this.currentFlight)){
_.set(currentStatus,'thresholdStatus',this.getThresholdStatusForFlight(this.currentFlight));
}
return currentStatus;
}

get currentTimeForFlightMonitor(){
return this.statistics.currentTime;
}};


module.exports=FlightMonitorPersonViewModel;
//# sourceMappingURL=flightMonitorPersonViewModel.js.map
